import zh_CN from '../data-picker'

export default zh_CN
